import { render, staticRenderFns } from "./MultiSelectCard.vue?vue&type=template&id=8ad756d2"
import script from "./MultiSelectCard.vue?vue&type=script&lang=js"
export * from "./MultiSelectCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports